import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getEstatesByGroupID,
    GetDivisionByEstateID,
    GetFieldsByCollectionPoint,
    getReportData
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllActiveGroups', null)
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

async function GetDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function GetFieldsByCollectionPoint(id) {
    var response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    let array = [];
    for (let item of Object.entries(response.data)) {
        array[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return array;
}

async function getReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        date: data.date,
        divisionID: parseInt(data.divisionID),
        regNumber: data.regNumber,
        fieldID: parseInt(data.fieldID)
    };
    const response = await CommonPost('/api/BlockWeighmentReport/GetReportData', null, model);
    return response.data;
}